export interface RoiInput {
  investment: number;         // poczatkowa inwestycja (zl)
  hourlyRate: number;         // Twoja stawka godzinowa (zl/h)
  hoursPerWeek: number;       // godziny/tydzien do zaoszczedzenia
  costPerLead: number;        // cena za leada (zl)
  extraLeadsPerMonth: number; // ile dodatkowych leadow/mies
}

export interface RoiResult {
  annualHoursSaved: number;
  annualTimeSavings: number;
  netAnnual: number;
  roiPercent: number;
  paybackMonths: number | null;
  annualLeads: number;
  annualLeadCost: number;
}

export function computeRoi(i: RoiInput): RoiResult {
  const annualHoursSaved = i.hoursPerWeek * 52;
  const annualTimeSavings = annualHoursSaved * i.hourlyRate;
  const netAnnual = annualTimeSavings - i.investment;
  const roiPercent = i.investment > 0 ? (netAnnual / i.investment) * 100 : 0;
  const monthlySavings = annualTimeSavings / 12;
  const paybackMonths = monthlySavings > 0 ? i.investment / monthlySavings : null;
  const annualLeads = i.extraLeadsPerMonth * 12;
  const annualLeadCost = annualLeads * i.costPerLead;
  return {
    annualHoursSaved,
    annualTimeSavings,
    netAnnual,
    roiPercent,
    paybackMonths,
    annualLeads,
    annualLeadCost,
  };
}
